(ns nosco.hooks
  (:require
   ["react" :as React]
   [hx.hooks :as hooks]
   [nosco.util :as util]))

(defn use-rerender
  "Return a function that will force a rerender"
  []
  (let [[_ set-state] (hooks/useState 0)]
    #(set-state inc)))

(defn maybe-use-event-listener
  "Adds an event listener to ref-or-el when active is true."
  ([active ref-or-el event f]
   (maybe-use-event-listener active ref-or-el event f nil nil))
  ([active ref-or-el event f deps]
   (maybe-use-event-listener active ref-or-el event f deps nil))
  ([active ref-or-el event f deps event-opts]
   (hooks/useLayoutEffect
    (fn []
      (when-let [el (if (object? ref-or-el) (.-current ref-or-el) ref-or-el)]
        (if active
          (do
            (.addEventListener el event f event-opts)
            (fn [] (.removeEventListener el event f event-opts)))
          (.removeEventListener el event f event-opts))))
    (concat [active] deps))))

(defn use-id
  "Returns a unique ID. If override is provided and is not nil, this value will
  be used as the ID instead (typically this is an ID provided by a parent)."
  ([prefix] (use-id nil prefix))
  ([override prefix]
   (let [id-ref (React/useRef)]
     (when override (set! (.-current id-ref) override))
     (when-not (.-current id-ref) (set! (.-current id-ref) (util/genid prefix)))
     (.-current id-ref))))

(defn- sync-scroll [e other-nodes f-ref]
  (let [scrolled-node (.-target e)
        dest-nodes (remove (fn [n] (identical? n scrolled-node)) other-nodes)]
    (doseq [dest dest-nodes]
      (.removeEventListener dest "scroll" (.-current f-ref))
      (.scrollTo dest (.-scrollLeft scrolled-node) 0)
      (.requestAnimationFrame js/window (fn []
                                          (.addEventListener dest "scroll"
                                                             (.-current f-ref)
                                                             #js {:passive false}))))))

(defn use-sync-scroll
  "Sync the scroll position of two nodes"
  ;; this could also support multiple nodes
  [a b]
  (let [do-sync-ref (React/useRef)]
    (hooks/useEffect
     (fn []
       (let [a (.-current a)
             b (.-current b)
             do-sync (fn [e]
                       (.requestAnimationFrame js/window
                                               #(sync-scroll e [a b] do-sync-ref)))]

         (set! (.-current do-sync-ref) do-sync)
         (when (and a b)
           (.addEventListener a "scroll"
                              do-sync
                              #js {:passive false})

           (.addEventListener b "scroll"
                              do-sync
                              #js {:passive false})
           (fn []
             (when (and a b)
               (.removeEventListener a "scroll" do-sync)
               (.removeEventListener b "scroll" do-sync))))))
     [a b])))

(defn use-unmount
  "Call f on component unmount but have reference
  to the latest values of state-deps.

  state-deps is a vector of component state variables
  that f is dependent on.

  f will be assumed to be N-arity where N is length of
  state-deps vector and all current values will be passed
  in order."
  [state-deps f]
  (let [deps-ref (React/useRef nil)]
    (hooks/useEffect
     (fn []
       (fn []
         (apply f (.-current deps-ref))))
     [])
    (hooks/useEffect
     (fn []
       (set! (.-current deps-ref) state-deps))
     state-deps)))
